<button
  type="button"
  class="step-key-pill"
  data-testid="step-key-pill"
  [attr.aria-label]="'testCases.form.testSteps.stepKeyCopy' | translate: { key: key() }"
  (click)="onClick($event)"
  (keydown)="onKeydown($event)"
>
  <app-code-id-chip [id]="key()" />
  @if (copied()) {
    <mat-icon class="step-key-pill__check" data-testid="step-key-pill-copied" aria-hidden="true">check</mat-icon>
  }
</button>
<span class="sr-only" aria-live="polite">{{ copied() ? ('common.copied' | translate) : '' }}</span>
